import React from 'react';
import classnames from 'classnames'

const CommonTextBox = ({name,label,value,onChange,error,placeholder}) => {

    return (
        <div className="form-group col-12">
            <label htmlFor="inputEmail4">{label} {require && <span className="text-danger">*</span>}</label>
             <textarea
                 rows={3}
                 name={name}
                 id={name}
                 value={value}
                 onChange={onChange}
                 className={classnames("form-control" ,{
                     'is-invalid': error
                 })}
                 placeholder={placeholder}/>
            {error && <span className='text-danger'>{error}</span>}
        </div>
    );
};

export default CommonTextBox;